<template>
  <div class="profile-container container">
    <div class="profile-portrait">
      <div class="profile-portrait-container">
      <figure>
        <img src="../../assets/images/ManjuPallam.jpg" alt="Manju Pallam"  >
          </figure>
         <div class="finger-print"><img src="@/assets/images/fingerprints/fingerprint-three.svg" alt=""></div>
      </div>
    </div>
    <div class="profile-statement">

      <h2>Dr Manju C Pallam</h2>
      <p class="job-title">Senior Lecturer</p>

      <p class="profile-statement-interviewer">Tell us a little bit about yourself</p>

      <p class="profile-statement-interviewed">I am a senior lecturer who is extremely interested and passionate about the inclusion and equality agenda. I am the international lead for the department.</p>

      <p class="profile-statement-interviewer">What inspires you within your role?</p>

      <p>The golden memories that I create for students and myself.</p>

      <p class="profile-statement-interviewer">How do you think MMU can best celebrate their Black, Asian, and Ethnic Minority staff and students?</p>

      <p>Highlight the journeys of prominent BME leaders in university, showcase their stories., offer mentorship from them, and provide an opportunity to network with them and connect with them.</p>

      <p class="profile-statement-interviewer">What are you most proud of?</p>

      <p>Being myself, as a human, Dr Manju C Pallam.</p>

    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

  .profile-container {
  flex-direction: row-reverse;
  }

  .profile-portrait-container {
    justify-content: flex-end;

        & figure {
      text-align: right;
    }
  }


</style>